import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scroll to top on route change UNLESS state.skipScrollTop is set (language switch)
export default function ScrollToTop() {
  const { pathname, hash, state } = useLocation();
  useEffect(() => {
    if (state && state.skipScrollTop) return;
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
    }
    window.scrollTo({ top: 0, left: 0, behavior: "instant" in window ? "instant" : "auto" });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);
  return null;
}
